import { Route } from 'types/route.type';
import Information from './components/information';

export const routes: Route[] = [
  {
    path: '/playground/info',
    component: Information,
  },
];
